import { jsx as _jsx } from "react/jsx-runtime";
import { PageButton } from '../PageButton';
export function PageMoreButton({ start, end, onClick }) {
    const handleClick = () => onClick(start, end);
    return _jsx(PageButton, { label: '...', onClick: handleClick, "data-test-id": `page-more-button-${start}-${end}` });
}
